import { render, staticRenderFns } from "./FormSelectListCountries.vue?vue&type=template&id=96df8dc6&"
import script from "./FormSelectListCountries.vue?vue&type=script&lang=js&"
export * from "./FormSelectListCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports